export default "__VITE_ASSET__PFh3SlfT__"